import React from 'react';

const Hospitality = () => {
  return (
    <div className="content-section">
      <div className="container mx-auto px-4">
        <div className="glass-card rounded-lg p-8 md:p-12">
          <h1 className="text-4xl font-bold text-primary mb-6 text-center">
            Hospitality & Media
          </h1>
          <div className="w-24 h-1 bg-gold mx-auto mb-8"></div>
          
          <div className="max-w-4xl mx-auto space-y-6">
            <p className="text-lg text-gray-700 leading-relaxed text-center mb-8">
              Vajreya Ventures provides expertise in hospitality management and media operations, delivering excellence in service, content, and strategic positioning.
            </p>

            <h2 className="text-2xl font-bold text-primary mb-4">Hospitality Services</h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
              <div className="bg-white border-2 gold-border rounded-lg p-6">
                <h3 className="text-xl font-bold text-primary mb-3">Hotel & Resort Management</h3>
                <p className="text-gray-700">
                  We provide comprehensive management services for hotels and resorts, focusing on operational excellence, guest satisfaction, and revenue optimization. Our expertise covers all aspects from staff training to service standards.
                </p>
              </div>

              <div className="bg-white border-2 gold-border rounded-lg p-6">
                <h3 className="text-xl font-bold text-primary mb-3">Service Excellence</h3>
                <p className="text-gray-700">
                  Our consultants help hospitality businesses implement world-class service standards, train staff in best practices, and create memorable guest experiences that drive loyalty and positive reviews.
                </p>
              </div>

              <div className="bg-white border-2 gold-border rounded-lg p-6">
                <h3 className="text-xl font-bold text-primary mb-3">Revenue Management</h3>
                <p className="text-gray-700">
                  We optimize revenue streams through dynamic pricing strategies, occupancy management, and ancillary revenue development. Our approach maximizes profitability while maintaining service quality.
                </p>
              </div>

              <div className="bg-white border-2 gold-border rounded-lg p-6">
                <h3 className="text-xl font-bold text-primary mb-3">Hospitality Investment</h3>
                <p className="text-gray-700">
                  We identify and evaluate hospitality investment opportunities, conduct feasibility studies, and provide strategic guidance for hotel acquisitions, development projects, and portfolio management.
                </p>
              </div>
            </div>

            <h2 className="text-2xl font-bold text-primary mb-4">Media Services</h2>
            
            <div className="space-y-4 mb-8">
              <div className="bg-white border-2 gold-border rounded-lg p-6">
                <h3 className="text-xl font-bold text-primary mb-3">Content Strategy</h3>
                <p className="text-gray-700">
                  We develop comprehensive content strategies for media companies and brands, covering content creation, distribution, audience engagement, and monetization. Our strategies align content with business objectives and market opportunities.
                </p>
              </div>

              <div className="bg-white border-2 gold-border rounded-lg p-6">
                <h3 className="text-xl font-bold text-primary mb-3">Digital Transformation</h3>
                <p className="text-gray-700">
                  We help traditional media companies navigate digital transformation, implementing new technologies, digital platforms, and online distribution channels while maintaining brand value and audience loyalty.
                </p>
              </div>

              <div className="bg-white border-2 gold-border rounded-lg p-6">
                <h3 className="text-xl font-bold text-primary mb-3">Media Investments</h3>
                <p className="text-gray-700">
                  We evaluate and execute investments in media companies, content production, digital platforms, and entertainment properties. Our analysis covers audience metrics, content value, and growth potential.
                </p>
              </div>

              <div className="bg-white border-2 gold-border rounded-lg p-6">
                <h3 className="text-xl font-bold text-primary mb-3">Brand Positioning</h3>
                <p className="text-gray-700">
                  We help media properties and hospitality brands develop strong market positioning through strategic messaging, visual identity, and targeted communication that resonates with their audience.
                </p>
              </div>
            </div>

            <h2 className="text-2xl font-bold text-primary mb-4">Integrated Solutions</h2>
            <p className="text-gray-700 mb-4">
              Our expertise in both hospitality and media enables us to provide integrated solutions:
            </p>
            <ul className="space-y-3 text-gray-700 mb-8">
              <li className="flex items-start">
                <span className="gold-text mr-2">•</span>
                <span><strong>Hospitality Marketing:</strong> Media strategies tailored for hotels and resorts</span>
              </li>
              <li className="flex items-start">
                <span className="gold-text mr-2">•</span>
                <span><strong>Content Creation:</strong> Professional content for hospitality brands</span>
              </li>
              <li className="flex items-start">
                <span className="gold-text mr-2">•</span>
                <span><strong>Digital Presence:</strong> Online reputation and social media management</span>
              </li>
              <li className="flex items-start">
                <span className="gold-text mr-2">•</span>
                <span><strong>Event Management:</strong> Conferences, launches, and promotional events</span>
              </li>
            </ul>

            <div className="bg-gradient-to-r from-primary to-primary-dark text-white rounded-lg p-8 text-center">
              <h3 className="text-2xl font-bold mb-4">Elevate Your Business</h3>
              <p className="mb-6">
                Transform your hospitality or media business with Vajreya Ventures' expertise.
              </p>
              <a 
                href="/contact" 
                className="inline-block px-8 py-3 bg-gold text-white font-semibold rounded-lg hover:bg-gold-dark transition-colors shadow-lg"
              >
                Get Started
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hospitality;